import Titles from '../Titles.vue'
 import TitlesTable from '../Views/TitlesTable';
 import TitlesCreate from '../Views/TitlesCreate';
 import TitlesUpdate from '../Views/TitlesUpdate';
 
 const TitlesRoute = [
     {
         path: '/academic/titles',
         meta: {
             name: {
                 en: 'Title',
                 es: 'Titulo'
             }
         },
         component: Titles,
         children: [
             {
                 path: '',
                 component: TitlesTable,
                 meta: { name: 'Index', group: 'portaladministrativo.academic', path: 'titles', permission: 'READ' }
             },
             {
                 path: 'create',
                 component: TitlesCreate,
                 meta: { name: 'Title Create', group: 'portaladministrativo.academic', path: 'titles', permission: 'CREATE' }
             },
             {
                 path: 'update/:id',
                 component: TitlesUpdate,
                 meta: { name: 'Title Update', group: 'portaladministrativo.academic', path: 'titles', permission: 'READ' }
             },
         ]
     }
 ];
 
 export default TitlesRoute;